/**
 * NYUFAZ portrait salon kiosk sizing.
 * Observed: CSS viewport ≈ 849×1340, device screen ≈ 848×1506.
 * USB face-camera rotate / device picker apply only on this class of device.
 * Microscope / macro capture is NOT gated by this helper.
 */

/** Same expression used in CSS (`nyufaz-salon-kiosk.css`). */
export const NYUFAZ_SALON_KIOSK_MQ = [
  '(orientation: portrait) and (min-width: 820px) and (max-width: 880px) and (min-height: 1280px) and (max-height: 1400px)',
  '(orientation: portrait) and (min-device-width: 820px) and (max-device-width: 880px) and (min-device-height: 1450px) and (max-device-height: 1560px)',
].join(', ');

function inRange(n, lo, hi) {
  return Number.isFinite(n) && n >= lo && n <= hi;
}

/**
 * @returns {boolean}
 */
export function isNyufazSalonKioskViewport() {
  if (typeof window === 'undefined') return false;
  try {
    if (window.matchMedia?.(NYUFAZ_SALON_KIOSK_MQ)?.matches) return true;
  } catch {
    /* ignore */
  }

  const w = Number(window.innerWidth) || 0;
  const h = Number(window.innerHeight) || 0;
  // CSS viewport ≈ 849 × 1340
  if (h > w && inRange(w, 820, 880) && inRange(h, 1280, 1400)) return true;

  const sw = Number(window.screen?.width) || 0;
  const sh = Number(window.screen?.height) || 0;
  // Device screen ≈ 848 × 1506 (portrait)
  if (sh >= sw && inRange(sw, 820, 880) && inRange(sh, 1450, 1560)) return true;
  if (sw >= sh && inRange(sh, 820, 880) && inRange(sw, 1450, 1560)) return true;

  return false;
}
